import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function fromLocalInput(local) {
  if (!local) return null;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

function createKasirMaintenanceMode() {
  const el = document.querySelector('[data-config]');
  let initial = {};
  try {
    initial = JSON.parse(el?.getAttribute('data-config') || '{}');
  } catch (_) {
    initial = {};
  }

  return {
    loading: false,
    saving: false,
    regenerating: false,
    bypassUrl: '',
    serverBypassUrl: '',
    form: {
      enabled: false,
      scope: 'both',
      title: 'Sistem sedang dalam pemeliharaan',
      message: 'Kami sedang melakukan pemeliharaan agar layanan makin baik. Silakan coba lagi nanti.',
      estimated_back_at_local: '',
    },

    init() {
      this.serverBypassUrl = initial.bypass_url || '';
      this.applyForm(initial);
      this.refresh();
    },

    applyForm(d) {
      if (!d || typeof d !== 'object') return;
      const scope = ['website', 'app', 'both'].includes(d.scope) ? d.scope : 'both';
      this.form = {
        enabled: !!d.enabled,
        scope,
        title: d.title || 'Sistem sedang dalam pemeliharaan',
        message: d.message || '',
        estimated_back_at_local: toLocalInput(d.estimated_back_at),
      };
      this.bypassUrl = d.bypass_url || '';
      if (this.bypassUrl) this.serverBypassUrl = this.bypassUrl;
    },

    effectiveBypassUrl() {
      return this.bypassUrl || this.serverBypassUrl || '';
    },

    scopeSummary() {
      if (this.form.scope === 'website') return 'website saja ditutup; aplikasi tetap normal.';
      if (this.form.scope === 'app') return 'aplikasi saja ditutup; website tetap normal.';
      return 'website & aplikasi ditutup.';
    },

    async refresh() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/maintenance');
        this.applyForm(data.data || {});
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat pengaturan.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async copyBypass() {
      const url = this.effectiveBypassUrl();
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
        window.toast?.('Link bypass disalin.', 'success');
      } catch (_) {
        window.toast?.('Gagal menyalin. Salin manual dari kolom.', 'error');
      }
    },

    async regenerateBypass() {
      if (this.regenerating) return;
      const hasToken = !!this.effectiveBypassUrl();
      if (hasToken && !window.confirm('Buat ulang token? Link bypass lama akan tidak berlaku.')) return;
      this.regenerating = true;
      try {
        const { data } = await axios.post('/api/v1/kasir/maintenance/bypass-token');
        this.applyForm(data.data || {});
        if (!this.effectiveBypassUrl()) {
          window.toast?.('Token belum tersedia. Pastikan migrasi bypass_token sudah dijalankan.', 'error');
          return;
        }
        window.toast?.(data.message || (hasToken ? 'Token diperbarui.' : 'Token dibuat.'), 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memperbarui token.', 'error');
      } finally {
        this.regenerating = false;
      }
    },

    async save() {
      if (this.saving) return;
      if (this.form.enabled && !['website', 'app', 'both'].includes(this.form.scope)) {
        window.toast?.('Pilih cakupan maintenance terlebih dahulu.', 'error');
        return;
      }
      this.saving = true;
      try {
        const payload = {
          enabled: !!this.form.enabled,
          scope: this.form.scope || 'both',
          title: this.form.title,
          message: this.form.message,
          estimated_back_at: fromLocalInput(this.form.estimated_back_at_local),
        };
        const { data } = await axios.put('/api/v1/kasir/maintenance', payload);
        this.applyForm(data.data || {});
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        const msg = e.response?.data?.message
          || Object.values(e.response?.data?.errors || {})?.[0]?.[0]
          || 'Gagal menyimpan.';
        window.toast?.(msg, 'error');
      } finally {
        this.saving = false;
      }
    },
  };
}

Alpine.data('kasirMaintenanceMode', createKasirMaintenanceMode);
